import { FC } from "react";
import { components, GroupBase, OptionProps } from "react-select";
import MapMarker from "~/components/Icons/fill/MapMarker";

type AddressOption = { value: string; label: string };

const Option: FC<OptionProps<AddressOption, false, GroupBase<AddressOption>>> = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <MapMarker />
      {data.label}
    </components.Option>
  );
};

Option.displayName = "Option";

export default Option;
